import { useTranslation } from "react-i18next";
import { FORT_AGENT_STATUS, MyFortAgentItem } from "@/api/types";
import { C } from "@/components/modal/home";
import { MyAgentActivatedCardV2 } from "./MyAgentActivatedCardV2";
import { MyAgentInactiveCardV2 } from "./MyAgentInactiveCardV2";
import { MyAgentsDialogsHost } from "./MyAgentsDialogsHost";
import { MyAgentsSectionSkeleton } from "./MyAgentsSectionSkeleton";

export type MyAgentsSectionBodyProps = {
  myAgentsLoading: boolean;
  /** 当前 Tab 筛选后用于展示的列表 */
  agents: MyFortAgentItem[] | undefined;
  /** 全部智能体（未筛选），用于 hasActivatedAgent 等全局判断 */
  allAgents?: MyFortAgentItem[] | undefined;
  onAddress: (agent: MyFortAgentItem) => void;
  onDeliveryStatus: (agent: MyFortAgentItem) => void;
  onTransfer: (agent: MyFortAgentItem) => void;
  onIncomeHistory: (agent: MyFortAgentItem) => void;
};

/** 「我的智能体」独立页：列表 / 空态 / 加载态 */
export function MyAgentsSectionBody({
  myAgentsLoading,
  agents,
  allAgents,
  onAddress,
  onDeliveryStatus,
  onTransfer,
  onIncomeHistory,
}: MyAgentsSectionBodyProps) {
  const { t } = useTranslation();

  if (myAgentsLoading) {
    return <MyAgentsSectionSkeleton />;
  }

  const agentList = agents ?? [];

  if (agentList.length === 0) {
    return (
      <div
        className="rounded-2xl flex flex-col items-center justify-center py-14 gap-2"
        style={{
          background:
            "linear-gradient(135deg, rgba(100,140,200,0.015) 0%, #0c1020 40%, #080c18 100%)",
          border: "1px solid rgba(100,140,200,0.06)",
        }}
      >
        <p className="text-sm font-medium" style={{ color: C.muted }}>
          {t("homePage.myAgents.emptyTitle")}
        </p>
        <p className="text-xs" style={{ color: C.dim }}>
          {t("homePage.myAgents.emptySubtitle")}
        </p>
      </div>
    );
  }

  const fullAgentList = allAgents ?? agentList;
  const hasActivatedAgent = fullAgentList.some(
    a => a.status === FORT_AGENT_STATUS.ACTIVATED
  );
  return (
    <>
      <div className="space-y-3">
        {agentList.map(agent =>
          agent.status === FORT_AGENT_STATUS.ACTIVATED ? (
            <MyAgentActivatedCardV2
              key={agent.agentId}
              agent={agent}
              onAddress={onAddress}
              onDeliveryStatus={onDeliveryStatus}
              onIncomeHistory={onIncomeHistory}
            />
          ) : (
            <MyAgentInactiveCardV2
              key={agent.agentId}
              agent={agent}
              onTransfer={() => onTransfer(agent)}
              hasActivatedAgent={hasActivatedAgent}
            />
          )
        )}
      </div>
      <MyAgentsDialogsHost agents={agentList} />
    </>
  );
}
